const source = state => state.source
const dossier = state => state.dossier
const dossiers = state => state.dossiers
const profiles = state => state.profiles
const visibleDossiers = state => state.visibleDossiers

export default {
  source,
  dossier,
  dossiers,
  profiles,
  visibleDossiers
}
